<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg783"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs787"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath797"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path795" /></clipPath></defs><g
     id="g789"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g791"><g
         id="g793"
         clip-path="url(#clipPath797)"><g
           id="g799"
           transform="translate(49.998,501.9995)"><path
             d="m 0,0 h 331.881 c 22.105,0.156 40.121,-17.954 40.121,-40 v -270.994"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.926;stroke-dasharray:none;stroke-opacity:1"
             id="path801" /></g><g
           id="g803"
           transform="translate(320.3057,89.9985)"><path
             d="m 0,0 h -150.308 v -20 c 0,-22.091 -17.908,-40 -40,-40 -22.091,0 -40,17.909 -40,40 v 392.001 c 0,22.092 -17.908,40 -40,40 -22.09,0 -40,-17.908 -40,-40 v -19.999 h 75 m 45,-412.002 H 32.881"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.926;stroke-dasharray:none;stroke-opacity:1"
             id="path805" /></g><g
           id="g807"
           transform="translate(427.2441,136.8008)"><path
             d="M 0,0 -5.389,2.232 C -15.51,6.424 -27.22,1.574 -31.411,-8.547 c -4.193,-10.121 0.658,-21.831 10.777,-26.023 l 5.39,-2.232 5.39,-2.232 C 0.266,-43.226 5.115,-54.936 0.924,-65.057 -3.268,-75.178 -14.979,-80.028 -25.099,-75.836 l -5.388,2.232"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.926;stroke-dasharray:none;stroke-opacity:1"
             id="path809" /></g><g
           id="g811"
           transform="translate(412,143.8467)"><path
             d="M 0,0 V 11.152"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.926;stroke-dasharray:none;stroke-opacity:1"
             id="path813" /></g><g
           id="g815"
           transform="translate(412,44.9985)"><path
             d="M 0,0 V 12.152"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.926;stroke-dasharray:none;stroke-opacity:1"
             id="path817" /></g><g
           id="g819"
           transform="translate(412,9.9985)"><path
             d="M 0,0 C 49.57,0 90,40.43 90,90 90,139.571 49.57,180 0,180 -49.57,180 -90,139.571 -90,90 -90,40.43 -49.57,0 0,0 Z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.926;stroke-dasharray:none;stroke-opacity:1"
             id="path821" /></g><path
           d="m 140,362 h 50 v 50 h -50 z"
           style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.926;stroke-dasharray:none;stroke-opacity:1"
           id="path823" /><path
           d="m 140,262 h 50 v 50 h -50 z"
           style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.926;stroke-dasharray:none;stroke-opacity:1"
           id="path825" /><path
           d="m 140,162 h 50 v 50 h -50 z"
           style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.926;stroke-dasharray:none;stroke-opacity:1"
           id="path827" /><g
           id="g829"
           transform="translate(240,407)"><path
             d="M 0,0 H 132"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.926;stroke-dasharray:none;stroke-opacity:1"
             id="path831" /></g><g
           id="g833"
           transform="translate(284.9961,307.0005)"><path
             d="M 0,0 H 87.004"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.926;stroke-dasharray:none;stroke-opacity:1"
             id="path835" /></g><g
           id="g837"
           transform="translate(240,207.0005)"><path
             d="M 0,0 H 97.001"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.926;stroke-dasharray:none;stroke-opacity:1"
             id="path839" /></g><g
           id="g841"
           transform="translate(240,366.999)"><path
             d="M 0,0 H 97.001"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.926;stroke-dasharray:none;stroke-opacity:1"
             id="path843" /></g><g
           id="g845"
           transform="translate(240,266.999)"><path
             d="M 0,0 H 56.501"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.926;stroke-dasharray:none;stroke-opacity:1"
             id="path847" /></g><g
           id="g849"
           transform="translate(240,166.9995)"><path
             d="M 0,0 H 56.501"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.926;stroke-dasharray:none;stroke-opacity:1"
             id="path851" /></g><g
           id="g853"
           transform="translate(239.9932,307.0005)"><path
             d="M 0,0 H 0.007"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:2.613;stroke-dasharray:none;stroke-opacity:1"
             id="path855" /></g></g></g></g></svg>
</template>
